import SharedAccountsLayout from "@components/core/SharedAccountsLayout";
import FaqSection from "./FaqSection";
import SupportSection from "./SupportSection";
import ArticlesFeaturedSection from "./ArticlesFeaturedSection";

function HelpCenter({ faqCategories, supportFeaturedQuestions, faqFeaturedArticles }) {
  return (
    <div>
      <SharedAccountsLayout title="help_center" />
      <div className="container help-container py-4 my-2 py-md-6 my-md-0">
        <div className="d-flex flex-column help-center-container">
          <div className="d-flex flex-column flex-md-row faq-support-section">
            <FaqSection
              faqCategories={faqCategories}
            />
            <SupportSection
              supportFeaturedQuestions={supportFeaturedQuestions}
            />
          </div>

          <ArticlesFeaturedSection
            faqFeaturedArticles={faqFeaturedArticles}
          />
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;
